import { Carriers } from '../constants/carriers';
import { CarrierAmeritas } from './ameritas';
import { CarrierConfig } from './carrierConfig';
import { CarrierLGA } from './lga';
import { CarrierNorthAmerican } from './northAmerican';
import { CarrierProtective } from './protective';
import { CarrierSeniorLife } from './seniorLife';

const carrierMap = new Map<string, CarrierConfig>();

carrierMap.set(Carriers.LGA, new CarrierLGA());
carrierMap.set(Carriers.AMERITAS, new CarrierAmeritas());
carrierMap.set(Carriers.NORTH_AMERICAN, new CarrierNorthAmerican());
carrierMap.set(Carriers.PROTECTIVE, new CarrierProtective());
carrierMap.set(Carriers.SENIOR_LIFE, new CarrierSeniorLife());

export class CarrierFactory {
  public static getCarrierConfig(carrier: string): CarrierConfig | undefined {
    return carrierMap.get(carrier);
  }
}
